import i18n from '../../utils/i18n'

export const DecimalBodyTemplate = (number?: number, fractionDigits = 3) => {
  if (number == null) return null

  const { language } = i18n

  return (
    <>
      {number.toLocaleString(language, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })}
    </>
  )
}
